import React from "react";
import { Modal, Button } from "react-bootstrap";

const DeleteConfirmation = ({
  showModal,
  hideModal,
  confirmModal,
  id,
  type,
  event,
  message,
}) => {
  return (
    <>
      <Modal
        show={showModal}
        onHide={hideModal}
        backdrop="static"
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>אישור הסרה</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="alert alert-danger">{message}</div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={hideModal}>
            ביטול
          </Button>
          <Button variant="danger" onClick={() => confirmModal(event)}>
            אישור הסרה
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
export default DeleteConfirmation;
